import { CalendarDate, maxMyActivityRangeDays } from "@sp-crm/core";
import { DatePreset, DateRangeValue } from "components/reports/date-presets";
import { differenceInCalendarDays } from "date-fns";
import { MyActivityRange } from "./my-activity";

export const lastThirtyDaysLabel = "Last 30 Days";

const defaultWindowDays = 30;

const trailingWindow = (today: CalendarDate, days: number) => ({
    start: today.addDays(1 - days),
    end: today,
});

const previousMonth = (today: CalendarDate) => {
    const start = today.monthBegin().addDays(-1).monthBegin();
    return { start, end: start.nextMonth().addDays(-1) };
};

export const activityDatePresets = (today: CalendarDate): DatePreset[] => [
    { label: "Last 7 Days", getRange: () => trailingWindow(today, 7) },
    {
        label: lastThirtyDaysLabel,
        getRange: () => trailingWindow(today, defaultWindowDays),
    },
    { label: "Last 90 Days", getRange: () => trailingWindow(today, 90) },
    { label: "This Month", getRange: () => ({ start: today.monthBegin(), end: today }) },
    { label: "Last Month", getRange: () => previousMonth(today) },
];

export const defaultActivityRange = (today: CalendarDate): DateRangeValue => {
    const window = trailingWindow(today, defaultWindowDays);
    return {
        startDate: window.start,
        endDate: window.end,
        activePreset: lastThirtyDaysLabel,
    };
};

const rangeDays = (range: DateRangeValue): number =>
    differenceInCalendarDays(range.endDate.dayStart(), range.startDate.dayStart()) + 1;

export const activityRangeIssue = (range: DateRangeValue): string | null => {
    const days = rangeDays(range);
    if (days < 1) {
        return "The end date is before the start date.";
    }
    if (days > maxMyActivityRangeDays) {
        return `That range covers ${days} days. My Activity shows up to 3 months at a time — pick a shorter range.`;
    }
    return null;
};

export const toActivityRangeInput = (range: DateRangeValue): MyActivityRange => ({
    startDate: range.startDate.toString(),
    endDate: range.endDate.toString(),
});
